import * as firestorm from 'firebase-firestorm'

export * from './Accounting/AccountingExport'
export * from './Accounting/AccountingExportRepository'
export * from './Accounting/GLCodeProductCategory'
export * from './Accounting/GLCodeProductCategoryRepository'
export * from './Accounting/GLCodeUPC'
export * from './Accounting/GLCodeUPCRepository'

export * from './Address/Address'
export * from './Address/AddressMapper'

export * from './Barcode/Barcode'
export * from './Barcode/BarcodeMapper'
export * from './Barcode/BarcodeCollection'

export * from './Chargify/ChargifyAccount'
export * from './Chargify/ChargifyAccountMapper'
export * from './Chargify/ChargifyAccountCollection'

export * from './Company/Company'
export * from './Company/CompanyCollection'
export * from './Company/CompanyTypeEnum'
export * from './Company/CompanyStatusEnum'
export * from './Company/CompanyMapper'
export * from './Company/FeatureEnum'
export * from './Company/ProductTypeEnum'
export * from './Company/CompanyService'

export * from './Notification/Notification'
export * from './Notification/NotificationCollection'
export * from './Notification/NotificationMapper'
export * from './Notification/NotificationStatusEnum'
export * from './Notification/NotificationClassificationEnum'
export * from './Notification/NotificationTypeEnum'

export * from './Notification/VendorOrderPlacedEmail/VendorOrderPlacedEmail'
export * from './Notification/VendorOrderPlacedEmail/IVendorOrderPlacedEmailData'
export * from './Notification/VendorOrderPlacedSMS/VendorOrderPlacedSMS'
export * from './Notification/VendorOrderPlacedSMS/IVendorOrderPlacedSMSData'

export * from './Notification/UserAccountCreatedEmail/UserAccountCreatedEmail'
export * from './Notification/UserAccountCreatedEmail/IUserAccountCreatedEmailData'
export * from './Notification/UserAccountCreatedSMS/UserAccountCreatedSMS'
export * from './Notification/UserAccountCreatedSMS/IUserAccountCreatedSMSData'
export * from './Notification/RepAccountCreatedSMS/RepAccountCreatedSMS'
export * from './Notification/RepAccountCreatedSMS/IRepAccountCreatedSMSData'
export * from './Notification/RepAccountCreatedEmail/RepAccountCreatedEmail'
export * from './Notification/RepAccountCreatedEmail/IRepAccountCreatedEmailData'
export * from './Notification/EODReportCreatedEmail/EODReportCreatedEmail'
export * from './Notification/EODReportCreatedEmail/IEODReportCreatedEmailData'
export * from './Notification/EODReportCreatedEmail/EODReportCreatedEmailTemplate'
export * from './Notification/SignupSuccessEmail/ISignupSuccessEmailData'
export * from './Notification/SignupSuccessEmail/SignupSuccessEmail'
export * from './Notification/RestaurantLimitExceededEmail/IRestaurantLimitExceededEmailData'
export * from './Notification/RestaurantLimitExceededEmail/RestaurantLimitExceededEmail'

export * from './Notification/SubscriptionReductionEmail/ISubscriptionReductionEmailData'
export * from './Notification/SubscriptionReductionEmail/SubscriptionReductionEmail'
export * from './Notification/SubscriptionReductionEmail/SubscriptionReductionEmailTemplate'

export * from './Notification/SubscriptionChangesEmail/ISubscriptionChangesEmailData'
export * from './Notification/SubscriptionChangesEmail/SubscriptionChangesEmail'
export * from './Notification/SubscriptionChangesEmail/SubscriptionChangesEmailTemplate'

export * from './Notification/RestaurantsDisabledEmail/IRestaurantsDisabledEmailData'
export * from './Notification/RestaurantsDisabledEmail/RestaurantsDisabledEmail'
export * from './Notification/RestaurantsDisabledEmail/RestaurantsDisabledEmailTemplate'
export * from './Notification/RestaurantsDisabledEmail/RestaurantsDisabledReasonEnum'

export * from './Onboarding/Onboarding'

export * from './Order/Order'
export * from './Order/OrderStatusEnum'
export * from './Order/OrderTypeEnum'
export * from './Order/OrderService'
export * from './Order/OrderEntry/OrderEntry'
export * from './Order/OrderCollection'
export * from './Order/OrderEntry/IVendorPriceListEntry'
export * from './Order/OrderEntry/OrderEntryStatusEnum'
export * from './Order/OrderMapper'

export * from './PriceList/PriceList'
export * from './PriceList/PriceListEntry/PriceListEntry'
export * from './PriceList/PriceListCollection'
export * from './PriceList/PriceListMapper'

export * from './ProductCategory/ProductCategory'
export * from './ProductCategory/ProductCategoryCollection'
export * from './ProductCategory/ProductCategoryMapper'
export * from './ProductCategory/ProductCategoryService'

export * from './Quickbooks'

export * from './User/IUserClaim'
export * from './User/AdminRoleEnum'
export * from './User/UserRoleEnum'
export * from './User/UserStatusEnum'
export * from './User/IFirebaseUserClaim'
export * from './User/User'
export * from './User/UserCollection'
export * from './User/UserMapper'

export * from './MasterCatalog/MasterCatalog'
export * from './MasterCatalog/MasterCatalogCollection'
export * from './MasterCatalog/MasterCatalogMapper'

export * from './Reminder/Reminder'
export * from './Reminder/ReminderCollection'
export * from './Reminder/ReminderMapper'

export * from './Par/Par'
export * from './Par/ParCollection'
export * from './Par/ParMapper'

export * from './ScheduledJob/ScheduledJob'
export * from './ScheduledJob/ScheduledJobCollection'
export * from './ScheduledJob/ScheduledJobMapper'
export * from './ScheduledJob/ScheduledJobTypeEnum'
export * from './ScheduledJob/RestaurantLimitDowngraded/RestaurantLimitDowngraded'

export * from './FavoriteList/FavoriteList'
export * from './FavoriteList/FavoriteListCollection'
export * from './FavoriteList/FavoriteListMapper'

export * from './UserSetting/UserSetting'
export * from './UserSetting/UserSettingCollection'
export * from './UserSetting/UserSettingMapper'

export * from './ProductPricing/ProductPricing'
export * from './ProductPricing/ProductPricingCollection'
export * from './ProductPricing/ProductPricingMapper'

export * from './QuickbooksSetting/QuickbooksSetting'
export * from './QuickbooksSetting/QuickbooksSettingCollection'
export * from './QuickbooksSetting/QuickbooksSettingMapper'

export * from './QuickbooksExport/QuickbooksExport'
export * from './QuickbooksExport/QuickbooksExportCollection'
export * from './QuickbooksExport/QuickbooksExportMapper'

export { Collection, IDocumentSnapshot, IQuerySnapshot, IQuery, DocumentChange, IEntity } from 'firebase-firestorm'

// noinspection TypeScriptUMDGlobal
export function initServerlessFirestore(firestore: firebase.firestore.Firestore) {
  firestorm.initialize(firestore)
}
